import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e31d65a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "master-detail-layout" }
const _hoisted_2 = { class: "list-panel" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h2", null, "Additional Information"),
    /*#__PURE__*/_createElementVNode("p", null, "Add your skills, certifications, and more")
  ])
], -1))
const _hoisted_4 = { class: "item-list" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-tools" }, null, -1))
const _hoisted_6 = { class: "list-item-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-item-title" }, "Skills", -1))
const _hoisted_8 = { class: "list-item-subtitle" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-award" }, null, -1))
const _hoisted_10 = { class: "list-item-content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-item-title" }, "Certifications", -1))
const _hoisted_12 = { class: "list-item-subtitle" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-folder" }, null, -1))
const _hoisted_14 = { class: "list-item-content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-item-title" }, "Projects", -1))
const _hoisted_16 = { class: "list-item-subtitle" }
const _hoisted_17 = { class: "detail-panel" }
const _hoisted_18 = {
  key: 0,
  class: "section-content"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Skills"),
  /*#__PURE__*/_createElementVNode("p", null, "Add your key skills grouped by category")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))
const _hoisted_21 = { class: "experience-header" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drag-handle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grip-vertical" })
], -1))
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "pills-input-container" }
const _hoisted_29 = { class: "pills-container" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x" }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["onUpdate:modelValue", "onKeydown"]
const _hoisted_34 = {
  key: 1,
  class: "section-content"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Certifications"),
  /*#__PURE__*/_createElementVNode("p", null, "Add your professional certifications and qualifications")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))
const _hoisted_37 = { class: "experience-header" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drag-handle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grip-vertical" })
], -1))
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "form-grid" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Issuing Organization", -1))
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Issue Date", -1))
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = {
  key: 2,
  class: "section-content"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Projects"),
  /*#__PURE__*/_createElementVNode("p", null, "Showcase your key projects")
], -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))
const _hoisted_53 = { class: "experience-header" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drag-handle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grip-vertical" })
], -1))
const _hoisted_55 = ["onUpdate:modelValue"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { class: "form-grid" }
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Dates", -1))
const _hoisted_62 = ["onUpdate:modelValue"]
const _hoisted_63 = { class: "form-group col-span-2" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Achievements", -1))
const _hoisted_65 = { class: "achievements-list" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drag-handle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grip-vertical" })
], -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet-point" }, "•", -1))
const _hoisted_68 = ["onUpdate:modelValue"]
const _hoisted_69 = ["onClick"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = ["onClick"]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))

import { ref, watch } from "vue";
import { VueDraggableNext } from "vue-draggable-next";
import type { AdditionalSkill, Certification, Project } from "../../../../server/src/models/Resume";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdditionalSection',
  props: {
    skills: {},
    certifications: {},
    projects: {}
  },
  emits: ["update:skills", "update:certifications", "update:projects"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedSection = ref("skills");
const skillInputs = ref<{ [key: number]: string }>({});
const techInput = ref("");

// Skills
function addSkillGroup() {
  const newSkills = [...props.skills];
  newSkills.push({
    skillGroup: "",
    skillDetails: [],
    uuid: crypto.randomUUID(),
  });
  emit("update:skills", newSkills);
}

function removeSkillGroup(index: number) {
  const newSkills = [...props.skills];
  newSkills.splice(index, 1);
  emit("update:skills", newSkills);
}

function addSkillItem(index: number) {
  if (!skillInputs.value[index] || !skillInputs.value[index].trim()) return;

  const newSkills = [...props.skills];
  const skill = newSkills[index];
  if (!skill.skillDetails) {
    skill.skillDetails = [];
  }

  skill.skillDetails.push(skillInputs.value[index].trim());
  emit("update:skills", newSkills);
  skillInputs.value[index] = "";
}

function removeSkillItem(groupIndex: number, skillIndex: number) {
  const newSkills = [...props.skills];
  const skill = newSkills[groupIndex];
  if (!skill.skillDetails) return;

  skill.skillDetails.splice(skillIndex, 1);
  emit("update:skills", newSkills);
}

function handleSkillBackspace(index: number) {
  if (!skillInputs.value[index]) {
    const newSkills = [...props.skills];
    const skill = newSkills[index];
    if (!skill.skillDetails?.length) return;

    skill.skillDetails.pop();
    emit("update:skills", newSkills);
  }
}

// Certifications
function addCertification() {
  const newCertifications = [...props.certifications];
  newCertifications.push({
    name: "",
    issuedBy: "",
    issueDate: "",
    uuid: crypto.randomUUID(),
  });
  emit("update:certifications", newCertifications);
}

function removeCertification(index: number) {
  const newCertifications = [...props.certifications];
  newCertifications.splice(index, 1);
  emit("update:certifications", newCertifications);
}

// Projects
function addProject() {
  const newProjects = [...props.projects];
  newProjects.push({
    name: "",
    dates: "",
    achievements: [
      {
        achievement: "",
        uuid: crypto.randomUUID(),
      },
    ],
    uuid: crypto.randomUUID(),
  });
  emit("update:projects", newProjects);
}

function removeProject(index: number) {
  const newProjects = [...props.projects];
  newProjects.splice(index, 1);
  emit("update:projects", newProjects);
}

function addAchievement(projectIndex: number) {
  const newProjects = [...props.projects];
  const project = newProjects[projectIndex];
  if (!project.achievements) {
    project.achievements = [];
  }
  project.achievements.push({
    achievement: "",
    uuid: crypto.randomUUID(),
  });
  emit("update:projects", newProjects);
}

function removeAchievement(projectIndex: number, achievementIndex: number) {
  const newProjects = [...props.projects];
  const project = newProjects[projectIndex];
  if (!project.achievements) return;

  project.achievements.splice(achievementIndex, 1);
  if (project.achievements.length === 0) {
    project.achievements.push({
      achievement: "",
      uuid: crypto.randomUUID(),
    });
  }
  emit("update:projects", newProjects);
}

// Emit updates
function emitSkillsUpdate() {
  emit("update:skills", [...props.skills]);
}

function emitCertificationsUpdate() {
  emit("update:certifications", [...props.certifications]);
}

function emitProjectsUpdate() {
  emit("update:projects", [...props.projects]);
}

// Add to script section after the existing imports
const vAutoResize = {
  mounted: (el: HTMLTextAreaElement) => {
    const resize = () => {
      el.style.height = "auto";
      el.style.height = el.scrollHeight + "px";
    };
    resize();
    el.addEventListener("input", resize);
    el.addEventListener("change", resize);
  },
  updated: (el: HTMLTextAreaElement) => {
    el.style.height = "auto";
    el.style.height = el.scrollHeight + "px";
  },
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["list-item", { active: selectedSection.value === 'skills' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedSection.value = 'skills'))
        }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString((_ctx.skills || []).length) + " skill groups", 1)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["list-item", { active: selectedSection.value === 'certifications' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedSection.value = 'certifications'))
        }, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString((_ctx.certifications || []).length) + " certifications", 1)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["list-item", { active: selectedSection.value === 'projects' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedSection.value = 'projects'))
        }, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, _toDisplayString((_ctx.projects || []).length) + " projects", 1)
          ])
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      (selectedSection.value === 'skills')
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", { class: "section-header" }, [
              _hoisted_19,
              _createElementVNode("button", {
                class: "btn-add",
                onClick: addSkillGroup
              }, [
                _hoisted_20,
                _createTextVNode(" Add Skill Group ")
              ])
            ]),
            _createVNode(_unref(VueDraggableNext), {
              "model-value": _ctx.skills,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:skills', $event))),
              group: "skills",
              handle: ".drag-handle",
              tag: "div",
              class: "experience-list"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (skill, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: skill.uuid,
                    class: "experience-card"
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((skill.skillGroup) = $event),
                        type: "text",
                        placeholder: "Skill Category (e.g., Programming Languages)",
                        class: "title-input",
                        onInput: emitSkillsUpdate
                      }, null, 40, _hoisted_23), [
                        [_vModelText, skill.skillGroup]
                      ]),
                      _createElementVNode("button", {
                        class: "btn-remove",
                        onClick: ($event: any) => (removeSkillGroup(index))
                      }, _hoisted_26, 8, _hoisted_24)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skill.skillDetails || [], (item, skillIndex) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: skillIndex,
                              class: "pill"
                            }, [
                              _createTextVNode(_toDisplayString(item) + " ", 1),
                              _createElementVNode("button", {
                                class: "pill-remove",
                                onClick: ($event: any) => (removeSkillItem(index, skillIndex))
                              }, _hoisted_32, 8, _hoisted_30)
                            ]))
                          }), 128))
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((skillInputs.value[index]) = $event),
                          type: "text",
                          placeholder: "Type a skill and press Enter",
                          class: "form-control pill-input",
                          onKeydown: [
                            _withKeys(_withModifiers(($event: any) => (addSkillItem(index)), ["prevent"]), ["enter"]),
                            _withKeys(($event: any) => (handleSkillBackspace(index)), ["backspace"])
                          ]
                        }, null, 40, _hoisted_33), [
                          [_vModelText, skillInputs.value[index]]
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["model-value"])
          ]))
        : (selectedSection.value === 'certifications')
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", { class: "section-header" }, [
                _hoisted_35,
                _createElementVNode("button", {
                  class: "btn-add",
                  onClick: addCertification
                }, [
                  _hoisted_36,
                  _createTextVNode(" Add Certification ")
                ])
              ]),
              _createVNode(_unref(VueDraggableNext), {
                "model-value": _ctx.certifications,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:certifications', $event))),
                group: "certifications",
                handle: ".drag-handle",
                tag: "div",
                class: "experience-list"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certifications, (cert, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: cert.uuid,
                      class: "experience-card"
                    }, [
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((cert.name) = $event),
                          type: "text",
                          placeholder: "Certification Name",
                          class: "title-input",
                          onInput: emitCertificationsUpdate
                        }, null, 40, _hoisted_39), [
                          [_vModelText, cert.name]
                        ]),
                        _createElementVNode("button", {
                          class: "btn-remove",
                          onClick: ($event: any) => (removeCertification(index))
                        }, _hoisted_42, 8, _hoisted_40)
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((cert.issuedBy) = $event),
                            type: "text",
                            class: "form-control",
                            placeholder: "e.g., AWS, Microsoft, Google",
                            onInput: emitCertificationsUpdate
                          }, null, 40, _hoisted_46), [
                            [_vModelText, cert.issuedBy]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((cert.issueDate) = $event),
                            type: "text",
                            class: "form-control",
                            placeholder: "e.g., June 2023",
                            onInput: emitCertificationsUpdate
                          }, null, 40, _hoisted_49), [
                            [_vModelText, cert.issueDate]
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["model-value"])
            ]))
          : (selectedSection.value === 'projects')
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createElementVNode("div", { class: "section-header" }, [
                  _hoisted_51,
                  _createElementVNode("button", {
                    class: "btn-add",
                    onClick: addProject
                  }, [
                    _hoisted_52,
                    _createTextVNode(" Add Project ")
                  ])
                ]),
                _createVNode(_unref(VueDraggableNext), {
                  "model-value": _ctx.projects,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:projects', $event))),
                  group: "projects",
                  handle: ".drag-handle",
                  tag: "div",
                  class: "experience-list"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: project.uuid,
                        class: "experience-card"
                      }, [
                        _createElementVNode("div", _hoisted_53, [
                          _hoisted_54,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((project.name) = $event),
                            type: "text",
                            class: "title-input",
                            placeholder: "Project Name",
                            onInput: emitProjectsUpdate
                          }, null, 40, _hoisted_55), [
                            [_vModelText, project.name]
                          ]),
                          _createElementVNode("button", {
                            class: "btn-remove",
                            onClick: ($event: any) => (removeProject(index))
                          }, _hoisted_58, 8, _hoisted_56)
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _hoisted_61,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((project.dates) = $event),
                              type: "text",
                              class: "form-control",
                              placeholder: "e.g., Feb 2023 - Present",
                              onInput: emitProjectsUpdate
                            }, null, 40, _hoisted_62), [
                              [_vModelText, project.dates]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_63, [
                            _hoisted_64,
                            _createElementVNode("div", _hoisted_65, [
                              _createVNode(_unref(VueDraggableNext), {
                                modelValue: project.achievements,
                                "onUpdate:modelValue": ($event: any) => ((project.achievements) = $event),
                                group: "achievements",
                                handle: ".drag-handle",
                                tag: "div",
                                onChange: emitProjectsUpdate
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.achievements, (achievement, achievementIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: achievement.uuid,
                                      class: "achievement-item"
                                    }, [
                                      _hoisted_66,
                                      _hoisted_67,
                                      _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": ($event: any) => ((achievement.achievement) = $event),
                                        class: "form-control",
                                        rows: "1",
                                        placeholder: "Describe a key achievement or responsibility...",
                                        onInput: emitProjectsUpdate
                                      }, null, 40, _hoisted_68), [
                                        [_vModelText, achievement.achievement],
                                        [vAutoResize]
                                      ]),
                                      _createElementVNode("button", {
                                        class: "btn-remove-small",
                                        onClick: ($event: any) => (removeAchievement(index, achievementIndex))
                                      }, _hoisted_71, 8, _hoisted_69)
                                    ]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"]),
                              _createElementVNode("button", {
                                class: "btn-add-achievement",
                                onClick: ($event: any) => (addAchievement(index))
                              }, [
                                _hoisted_73,
                                _createTextVNode(" Add Achievement ")
                              ], 8, _hoisted_72)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["model-value"])
              ]))
            : _createCommentVNode("", true)
    ])
  ]))
}
}

})